import React, {Component} from 'react'

import {
  Typography
} from 'material-ui'

// import {
  // Primary,
  // bgWhite,
// } from '../helper/consts'

import Fade from 'material-ui/transitions/Fade'

import '../styles/ViewMoreFeedBtn.css'

// const style = {
//   btn:{
//     color:Primary,
//     cursor: 'pointer',
//     textAlign: 'center',
//     borderBottom: '1px solid #d9d9d9',
//     lineHeight: '0.1em',
//     margin: '10px 0 20px',
//   },
//   btnSpan:{
//     background: bgWhite,
//     padding: '0 10px',
//   }
// }

export default class ViewMoreFeedBtn extends Component{
  render(){
    const {onClickfunction, text} = this.props;
    return(
      <Fade in={true} key='view_more_feed_btn' ><Typography id='btn' className='cardWidth' onClick={onClickfunction} type="subheading"><span id='btnSpan' >{text}</span></Typography></Fade>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ViewMoreFeedBtn.js